import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import Select from 'react-select';
import Swal from "sweetalert2";
import { Modal, Pagination } from 'react-bootstrap';
import { getPropertyTypesAction, deletePropertyTypeAction, createPropertyTypeAction, updatePropertyTypeAction } from '../../store/actions/propertyType/PropertyTypeActions';

const fieldOptions = [
  { value: 'furnishedStatus', label: 'Furnished Status' },
  { value: 'propertyAge', label: 'Property Age' },
  { value: 'reraApproved', label: 'RERA Approved' },
  { value: 'reraId', label: 'RERA ID' },
  { value: 'carpetArea', label: 'Carpet Area' },
  { value: 'buildUpArea', label: 'Build Up Area' },
  { value: 'superBuildUpArea', label: 'Super Build Up Area' },
  { value: 'propertyFeatures', label: 'Property Features' },
  { value: 'facingDirection', label: 'Facing Direction' },
  { value: 'floorPlanUrls', label: 'Floor Plan URLs' },
  { value: 'area', label: 'Area' },
  { value: 'amenity', label: 'Amenity' },
];

const PropertyType = () => {
	const dispatch = useDispatch();

	const { PropertyTypes, loading } = useSelector((state) => state.PropertyTypes);
	const PropertyTypeRows = PropertyTypes?.rows || [];
	const totalPages = PropertyTypes?.pages || 1;
	const [formErrors, setFormErrors] = useState({});
	const [searchTerm, setSearchTerm] = useState('');

	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize] = useState(10);
	const [addCard, setAddCard] = useState(false);

	const [addFormData, setAddFormData] = useState({
		name: '',
		fields: [],
		isEnabled: true
	});

	const [editMode, setEditMode] = useState(false);
	const [editpropertyTypeData, setEditpropertyTypeData] = useState(null);

	const handleAddFormChange = (input, customValue) => {
		if (input?.target) {
			// Native input event
			const { name, value } = input.target;
			setAddFormData((prev) => ({
				...prev,
				[name]: name === "isEnabled" ? value === "true" : value
			}));

			setFormErrors((prevErrors) => ({
				...prevErrors,
				[name]: ''
			}));
		} else {
			// Custom input like react-select
			const { name, value } = customValue;
			setAddFormData((prev) => ({
				...prev,
				[name]: value
			}));

			setFormErrors((prevErrors) => ({
				...prevErrors,
				[name]: ''
			}));
		}
	};

	const handleAddFormSubmit = async (event) => {
		event.preventDefault();

		const { name, fields } = addFormData;
		const errors = {};

		if (!name.trim()) errors.name = "Name is required.";

		setFormErrors(errors);

		if (Object.keys(errors).length > 0) return;

		const payload = {
			name,
			fields,
			isEnabled: addFormData.isEnabled
		};

		try {
			let response;
			if (editMode && editpropertyTypeData?._id) {
				response = await dispatch(updatePropertyTypeAction(editpropertyTypeData._id, payload));
			} else {
				response = await dispatch(createPropertyTypeAction(payload));
			}

			if (response.data.success) {
				Swal.fire({ icon: 'success', title: 'Success!', text: editMode ? 'Property type updated' : 'Property type added' });
				resetForm();
				dispatch(getPropertyTypesAction(currentPage, pageSize, searchTerm));
			} else {
				Swal.fire({ icon: 'error', title: 'Error', text: response.data?.msg || 'Something went wrong' });
			}
		} catch (error) {
			Swal.fire({ icon: 'error', title: 'Error', text: error?.response?.data?.msg || 'Unexpected error occurred' });
		}
	};

	const handleDelete = async (policyId) => {
		const result = await Swal.fire({
			title: "Are you sure?",
			text: "You won't be able to revert this!",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes, delete it!"
		});

		if (result.isConfirmed) {
			const response = await dispatch(deletePropertyTypeAction(policyId));
			if (response.data.success) {
				Swal.fire("Deleted!", "The property type has been deleted.", "success");
				dispatch(getPropertyTypesAction(currentPage, pageSize, searchTerm));
			} else {
				Swal.fire("Deleted!", "Check.", "Test");
			}
		}
	};

	const handleEdit = (data) => {
		setEditMode(true);
		setEditpropertyTypeData(data);
		setFormErrors({});
		setAddFormData({
			name: data.name,
			fields: data.fields,
			isEnabled: data.isEnabled
		});
		setAddCard(true);
	};

	const resetForm = () => {
		setAddCard(false);
		setEditMode(false);
		setEditpropertyTypeData(null);
		setAddFormData({
			name: '',
			fields: [],
			isEnabled: true
		});
	};

	const searchRole = () => {
		dispatch(getPropertyTypesAction(currentPage, pageSize, searchTerm));
	}

	useEffect(() => {
		dispatch(getPropertyTypesAction(currentPage, pageSize, searchTerm));
	}, [dispatch, currentPage, pageSize, searchTerm]);

	useEffect(() => {
		// dispatch(getAllPoliciesAction());
	}, [dispatch]);

	return (
		<>
			<div className="col-12">
				<Modal className="modal fade" show={addCard} onHide={resetForm}>
					<form onSubmit={handleAddFormSubmit}>
						<div className="modal-header">
							<h4 className="modal-title fs-20">{editMode ? 'Edit Property Type' : 'Add Property Type'}</h4>
							<button type="button" className="btn-close" onClick={resetForm}></button>
						</div>
						<div className="modal-body">
							<div className="add-contact-box">
								<div className="add-contact-content">
									<div className="form-group mb-3">
										<label>Name</label>
										<input type="text" className={`form-control ${formErrors.name ? 'is-invalid' : ''}`} name="name" value={addFormData.name} onChange={handleAddFormChange} placeholder="Name"  />
										{formErrors.name && <div className="invalid-feedback">{formErrors.name}</div>}
									</div>
									<div className="form-group mb-3">
										<label>Fields</label>
										<div className="form-group">
											<Select
												isMulti
												name="fields"
												options={fieldOptions}
												value={fieldOptions.filter(option => addFormData.fields?.includes(option.value))}
  												onChange={(selectedOptions) => {
													const values = selectedOptions.map(option => option.value);
													handleAddFormChange(null, { name: 'fields', value: values });
												}}
											/>
										</div>
									</div>
									<div className="form-group mb-3">
										<label>Status</label>
										<select name="isEnabled" className={`form-control ${formErrors.isEnabled ? 'is-invalid' : ''}`} value={addFormData.isEnabled} onChange={handleAddFormChange}>
											<option value={true}>Enabled</option>
											<option value={false}>Disabled</option>
										</select>
										{formErrors.isEnabled && <div className="invalid-feedback">{formErrors.isEnabled}</div>}
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<button type="submit" className="btn btn-primary">{editMode ? "Update" : "Add"}</button>
							<button type="button" onClick={resetForm} className="btn btn-danger">Discard</button>
						</div>
					</form>
				</Modal>

				<div className="card">
					<div className="card-header d-flex flex-wrap justify-content-between align-items-center gap-3">
						<h4 className="card-title mb-0">Property Type List</h4>
						
						<div className="input-group w-50">
							<input
								type="text"
								className="form-control"
								placeholder="Search by name..."
								onChange={(e) => setSearchTerm(e.target.value)} 
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										searchRole();
									}
								}}
							/>
							<span onClick={searchRole} className="input-group-text" style={{ cursor: 'pointer' }}>
								<i className="fa fa-search"></i>
							</span>
						</div>

						<button className="btn btn-primary shadow btn-xs sharp me-2" onClick={() => setAddCard(true)}>
							<i className="fa fa-plus"></i>
						</button>
					</div>
					<div className="card-body">
						<div className="table-responsive">
							<table className="table table-striped">
								<thead>
									<tr>
										<th>Name</th>
										<th>Enabled</th>
										<th>Action</th>
									</tr>
								</thead>
								<tbody>
									{loading ? (
										Array.from({ length: 5 }).map((_, idx) => (
											<tr key={idx}>
												<td colSpan="3">
													<div className="skeleton-loader" style={{ height: 30, width: '100%', background: '#eee', borderRadius: 4 }}></div>
												</td>
											</tr>
										))
									) : PropertyTypeRows.length === 0 ? (
										<tr><td colSpan="3">No property types found.</td></tr>
									) : (
										PropertyTypeRows.map((policy) => (
											<tr key={policy._id}>
												<td>{policy.name}</td>
												<td className={policy.isEnabled ? 'text-success' : 'text-danger'}>
													{policy.isEnabled ? 'True' : 'False'}
												</td>
												<td>
													<div className="d-flex">
														<button className="btn btn-secondary shadow btn-xs sharp me-2" onClick={() => handleEdit(policy)}>
															<i className="fa fa-pencil"></i>
														</button>
														<button className="btn btn-danger shadow btn-xs sharp" onClick={() => handleDelete(policy._id)}>
															<i className="fa fa-trash"></i>
														</button>
													</div>
												</td>
											</tr>
										))
									)}
								</tbody>
							</table>
						</div>

						<div className="d-flex justify-content-between align-items-center mt-4">
							<div></div> {/* Empty div to align right side content */}
							<div className="d-flex align-items-center gap-3">
								<span className="text-muted">Total Property Types: {PropertyTypes?.total || PropertyTypeRows.length}</span>
								<Pagination className="pagination-gutter pagination-circle pagination mb-0">
									<Pagination.Prev
										disabled={currentPage === 1}
										onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
									/>
									{Array.from({ length: totalPages }, (_, i) => (
										<Pagination.Item
											key={i + 1}
											active={i + 1 === currentPage}
											onClick={() => setCurrentPage(i + 1)}
										>
											{i + 1}
										</Pagination.Item>
									))}
									<Pagination.Next
										disabled={currentPage === totalPages}
										onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
									/>
								</Pagination>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default PropertyType;
